import React from 'react';
import {Box} from 'grommet';
import AppSidebar from "../components/AppSidebar/AppSidebar";
import ThemeService from "../services/ThemeService";
import {ToastContainer} from "react-toastify";

function SidebarLayout({mainComponent}) {
    return (
        <Box fill={true} direction={'row'} style={ThemeService.getCssVariables()}>
            <Box>
                <AppSidebar />
            </Box>
            <Box animation='slideLeft' fill={true} overflow={'auto'}>
                {mainComponent}
                <ToastContainer
                    position="bottom-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Box>
        </Box>
    );
}

export default SidebarLayout;
